// Backend key from permissions.json → AI → Settings (premium plan). It guards GET /api/ai/settings and GET /api/ai/usage,
// both read-only: a school cannot change its own AI settings, which are platform-managed.
export const ASK_TROVIX_SETTINGS_PERMISSIONS = {
  view: "AI.Settings.view",
} as const;
